export const constants = {
    clientMainPage: "https://mbank.pl/",

    dateFormat: "dd.MM.yyyy",
    timeFormat: "HH:mm",

    recommendedBrowsers: ["Chrome", "Edge", "Safari"],

    recommendedBrowsersFullNames: ["Google Chrome", "Microsoft Edge", "Safari"],

    joinUrlHashQueryParameterName: "id",
    languageCodeQueryParameterName: "lang",

    languageCodes: {
        english: "en",
        czech: "cs",
        slovakian: "sk",
    },
};

export const validation = {};
